__turbopack_context__.v({
  "buttons": "CalcContent-module-scss-module__nOUJVW__buttons",
  "calcButton": "CalcContent-module-scss-module__nOUJVW__calcButton",
  "startButton": "CalcContent-module-scss-module__nOUJVW__startButton",
});
